// extracted by mini-css-extract-plugin
export default {"infoButton":"TalkDestInfo_infoButton__wJ-ts"};